module.exports = __webpack_public_path__ + "img/anf8.748453ff.png";